// AttachmentsApi.js
// API functions for RAG file attachments on sections/documents

import { apiCall } from '../ApiUtils';
import { getAuthHeaders } from '../ApiUtils';

export const attachmentsApi = {
  async listAttachments(parentId, classContext) {
    return await apiCall(`/document-editor/attachments?parent_id=${parentId}`, { method: 'GET' }, classContext);
  },

  async uploadAttachment(parentId, parentType, file, classContext) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('parent_id', parentId);
    formData.append('parent_type', parentType);

    // Get auth headers but strip Content-Type — the browser must set it automatically
    // with the multipart/form-data boundary when sending FormData
    const headers = getAuthHeaders(classContext);
    delete headers['Content-Type'];

    const url = `/api/document-editor/attachments`;
    const response = await fetch(url, {
      method: 'POST',
      headers,
      credentials: 'include',
      cache: 'no-store',
      body: formData,
    });
    return response.json();
  },

  async deleteAttachment(attachmentId, classContext) {
    return await apiCall(`/document-editor/attachments/${attachmentId}`, { method: 'DELETE' }, classContext);
  },

  getContentUrl(attachmentId, classContext) {
    const params = new URLSearchParams();
    if (classContext?.class_id && classContext.class_id !== 'all') {
      params.set('class_id', classContext.class_id);
    }
    const qs = params.toString() ? `?${params.toString()}` : '';
    return `/api/document-editor/attachments/${attachmentId}/content${qs}`;
  },

  // Fetch the file as a blob (bypasses the dev-server proxy's Accept:text/html block)
  // and open it in a new tab via an object URL.
  async openInNewTab(attachmentId, classContext) {
    const url = this.getContentUrl(attachmentId, classContext);
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: getAuthHeaders(classContext),
        credentials: 'include',
        cache: 'no-store',
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(blob);
      const win = window.open(objectUrl, '_blank');
      // Revoke the object URL after the tab has opened
      if (win) setTimeout(() => URL.revokeObjectURL(objectUrl), 10000);
    } catch (err) {
      console.error('Failed to open attachment:', err);
      alert('Could not open file. Please try again.');
    }
  },
};
